module.exports = __webpack_public_path__ + "static/media/Forestry-BG-Front-Layer-One.3f82a0d1.png";